import { FC, Fragment, JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { AddRounded as AddRoundedIcon } from '@mui/icons-material';
// components
import ProductSizeTable from './ProductSizeTable';
// constant, styles, reducer, graphql
import { flexCenterBetween } from 'styles/commonComponentStyle';
import { ADD_NEW_TEXT, ADD_PRODUCT_SIZE_ROUTE, PRODUCT_SIZE_TEXT } from 'constants/index';

const ProductType: FC = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <Box sx={flexCenterBetween}>
        <Typography variant="h5">{PRODUCT_SIZE_TEXT}</Typography>
        <Button variant="contained" color="primary" onClick={() => navigate(ADD_PRODUCT_SIZE_ROUTE)}>
          <AddRoundedIcon />
          {ADD_NEW_TEXT}
        </Button>
      </Box>
      <ProductSizeTable />
    </Fragment>
  );
};

export default ProductType;
